export const MapColorWithAntd = new Map([
  ['success', 'ant-tag-success'],
  ['error', 'ant-tag-error'],
  ['warning', 'ant-tag-warning'],
  ['info', 'ant-tag-info'],
  ['pink', 'ant-tag-pink'],
  ['red', 'ant-tag-red'],
  ['yellow', 'ant-tag-yellow'],
  ['orange', 'ant-tag-orange'],
  ['cyan', 'ant-tag-cyan'],
  ['green', 'ant-tag-green'],
  ['blue', 'ant-tag-blue'],
  ['purple', 'ant-tag-purple'],
  ['geekblue', 'ant-tag-geekblue'],
  ['magenta', 'ant-tag-magenta'],
  ['volcano', 'ant-tag-volcano'],
  ['gold', 'ant-tag-gold'],
  ['lime', 'ant-tag-lime'],
  ['default', 'ant-tag-default'],
  ['processing', 'ant-tag-processing']
]);
